// extracted by mini-css-extract-plugin
export default {"name":"UserName_name__pXODs"};